<div class="filter-tray">
    <div class="tray-items" [formGroup]="byTitleForm">
        <div formArrayName="titles">
            <div class="tray-row" *ngFor="let titleCtrl of titles.controls; let i = index">
                <input
                    type="text"
                    [formControl]="titleCtrl"
                    (click)="setEditingIndex(i)"
                    minlength="3"
                    class="title-input"
                    placeholder="..."
                    />
                <button type="button" class="row-remove" (click)="removeField(i)" [disabled]="titles.length <= 1">
                    <i class="material-icons-outlined">close</i>
                </button>
            </div>
        </div>
    </div>
    <div class="tray-footer">
        <button type="button" class="add-btn" (click)="addTitleField()">
            <i class="material-icons-outlined">add</i>
        </button>
        <not [filter]="byTitleFilter" (filterChanged)="onFilterChanged($event)"></not>
        <button class="apply-btn" type="button" (click)="apply()">{{ 'filter.apply' | translate }}</button>
    </div>
</div>
